import {
    CategoryScale,
    Chart as ChartJS, Filler, Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title, Tooltip
} from "chart.js";
import {useEffect, useMemo, useState} from "react";
import { Line } from 'react-chartjs-2';
import {CHART_COLORS} from "../consts/COLOR_SETS.js";
import "../style.css";
import {BaseChart} from "./BaseChart";

export const MiniLineChart = ({ data, dataSets, labels, title = "", isDataLoaded = false, fill = true, borderWidth = 2 }) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        Filler
    );

    const digestedData = useMemo(() => {
        if(data?.length) {
            return {
                labels,
                datasets: dataSets.map((dataSet, index) => {
                    return {
                        label: dataSet.label,
                        data: dataSet.values,
                        borderColor: dataSet.borderColor ? dataSet.borderColor : dataSet.isGreyed ? 'rgba(222, 222, 222, 0.5)' : CHART_COLORS[index]?.solid,
                        backgroundColor: dataSet.color ? dataSet.color : dataSet.isGreyed ? 'rgba(222, 222, 222, 0.5)' : CHART_COLORS[index]?.transparent,
                        fill,
                        borderWidth,
                    };
                })
            };
        } else {
            return {
                labels: [],
                datasets: [],
            };
        }
    }, [data]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false
            },
            tooltip: {
                enabled: false
            }
        },
        tension: 0.3,
        scales: {
            y: {
                ticks: {
                    precision: 0
                },
                display: false,
            },
            x: {
                display: false,
            }
        },
        elements: {
            point: {
                radius: 0,
                hoverRadius: 2, // ex.: to make it bigger when user hovers put larger number than radius.
            }
        },
        layout: {
            padding: 2,
        }
    };

    return <BaseChart
        data={digestedData}
        options={options}
        title={title}
        Chart={Line}
        isDataLoaded={isDataLoaded}
    />;
}